export const DEFAULT_CRM_TOKEN = 'xgr69wzwj1j';
export const brandLogo = `${window.assetsLocation}/images/logo.svg`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/showcase.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.jpg`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = ['5'];
export const faqArticleIds = ['4', '6'];
